/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from "@insticator/insticator-ui";

/* ++++++++++ --------------- EXISTING PAYMENTS : STYLES --------------- ++++++++++ */
export default {
  existingpayments: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    '& .title': {
      padding: pxToEm(32),
      '& h2': {
        fontSize: pxToEm(15),
      }
    },
    '& .name-paymentterm': {
      display: 'flex',
      flexDirection: 'column',
      padding: pxToEm(32),
      paddingBottom: pxToEm(0),
      alignSelf: 'flex-start',
      '& .title': {
        padding: pxToEm(0),
        paddingTop: pxToEm(0),
        margin: pxToEm(0),
        '& p':{
          fontSize: pxToEm(14),
          paddingBottom: pxToEm(16),
        }
      }
    },
    '& th': {
      zIndex: 0,
    }
  }
};